import mixin from './mixin';
import TreatmentFilter from './components/TreatmentFilter.vue';

const treatmentOverviewApp = {
	components: { TreatmentFilter },
	mixins: [mixin],
	data() {
		return {
			dataJson: null,
			treatments: [],
			dataRegions: [],
			filterRegions: [],
			showModal: false,
		};
	},
	computed: {
		filteredItems() {
			if (!this.treatments) return [];
			if (!this.filterRegions.length) return this.treatments;
			return this.treatments.filter((treatment) => this.filterOnRegions(treatment));
		},
		regions() {
			if (!this.dataRegions || !this.treatments || !this.treatments.length) return [];
			return this.dataRegions.filter(region => this.treatments.some(item => item.regions.map(region => region.Name).includes(region.Naam)));
		},
	},
	methods: {
		filterOnRegions(treatment) {
			return treatment.regions
				.map((r) => r.Name)
				.some((name) => this.filterRegions.includes(name));
		},
		onFilterRegion(regionName) {
			const newFilterRegions = [...this.filterRegions];
			const index = newFilterRegions.indexOf(regionName);
			if (index > -1) {
				newFilterRegions.splice(index, 1);
			} else {
				newFilterRegions.push(regionName);
			}
			this.filterRegions = newFilterRegions;
			const url = new URL(location);
			if (this.filterRegions.length) {
				url.searchParams.set('regions', this.filterRegions.join('+'));
			} else {
				url.searchParams.delete('regions');
			}
			history.pushState({}, '', url);
		},
		regionCount(region) {
			if (!region) return;
			return this.treatments.filter((treatment) =>
				treatment.regions.map((r) => r.Name).includes(region)
			).length;
		},
		openModal() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
	},
	created() {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		if (urlParams.has('regions')) {
			this.filterRegions = urlParams.get('regions').split('+');
		}
	},
	mounted() {
		if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
		if (this.dataJson.SubPages) this.treatments = this.dataJson.SubPages;
		if (this.dataJson.Regios) this.dataRegions = this.dataJson.Regios;
	},
};

export default treatmentOverviewApp;
